export enum TimeclockEvents {
  CREATED = "CREATED"
}
